export class TestQItemVerification {
    id: number;
	idItem: number;
	verification: string;
	processingType: number;
	testQDataMultiple :TestQDataMultiple[];
}

export class TestQDataMultiple {
    id: number;
	idVerification: number;
	expectedResultDesc: string;
	expectedResultRhDesc: string;
	resultDesc: string[];
	combined: boolean;
}

export enum VerificationProcessingTypeEnum {
	PROBES_CORRECTLY = 1,
	MEETS_CRITERIA = 2,
	COMPLETY_OPEN_DOOR = 3,
	COMPLETY_CUT_ELECTRIC = 4,
	DEVIATION_INSTALLATION = 9,
	DEVIATION_EXECUTION = 5,
	DEVIATION_WORKING = 6,
	BIOINDICATOR = 7,
	ENDOTOXIN = 8
}